import { getJobWithCompany } from '../../../helpers/format';
import CardIcon from '../../../components/shared/card/CardIcon';
import React from 'react';
import styled from 'styled-components';
import Button from '../../../components/shared/Button';
import QRCodeScanner from '../../../components/qr-scanner';
import { TAB_ATTENDEES } from '../../../constants/app';
import { getWhosHereId } from '../../../helpers/helpers';
import { extractAttendeeIdFromQR } from '../../../helpers/qrCode';

const UserContainer = styled.div`
  cursor: pointer;
  text-align: center;
`;

const UserName = styled.div`
  font-size: 1.8rem;
  font-weight: 500;
`;

const UserJob = styled.div`
  padding: 5px 0;
  font-size: 1.4rem;
  color: ${props => props.theme.ashesGrey};
`;

const QrCodeHeading = styled.div`
  margin: 20px 0;
  font-weight: 600;
  font-size: 1.6rem;
`;

const QrCode = styled.img`
  width: 100%;
  max-width: 150px;
  margin: 15px auto 25px;
  display: block;
`;

const HelpText = styled.div`
  font-size: 1.2rem;
  margin: 10px 0 0;
  color: ${props => props.theme.ashesGrey};
`;

class UserQrCode extends React.Component {
  state = {
    showScanner: false
  };

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onClickScanAttendee = () => {
    this.setState({ showScanner: true });
  };

  onClickPeopleScanned = () => {
    const { appId, eventId } = this.props.matchParams;
    this.props.history.push(`/apps/${appId}/events/${eventId}/scanned-attendees`);
  };

  handleScanResult = (result) => {
    if (result && result.length > 0) {
      const attendeeId = extractAttendeeIdFromQR(result);
      
      if (attendeeId) {
        this.addToFavorites(attendeeId);
        this.redirectToAttendeeDetails(attendeeId);
      }
    }
    
    if (this._isMounted) {
      this.setState({ showScanner: false });
    }
  };

  addToFavorites = (attendeeId) => {
    const { appId, eventId } = this.props.matchParams;
    const { postFavorite, updateFavModel } = this.props;
    
    const favoriteData = {
      app_id: +appId,
      event_id: +eventId,
      favorite_id: attendeeId,
      favorite_type: 'attendee'
    };
    postFavorite(favoriteData);
    
    updateFavModel({
      data: { id: attendeeId, is_favorite: true },
      type: 'attendee'
    });
  };

  redirectToAttendeeDetails = (attendeeId) => {
    const { appId, eventId } = this.props.matchParams;
    const { menuItems } = this.props;
    
    const whosHereId = getWhosHereId(menuItems);
    
    const attendeeDetailsUrl = `/apps/${appId}/events/${eventId}/whos_here/${whosHereId}/tab_attendees/attendee_details/${attendeeId}`;
    
    this.props.history.push(attendeeDetailsUrl);
  };

  handleCloseScanner = () => {
    this.setState({ showScanner: false });
  };

  handleManualSearch = () => {
    const { appId, eventId } = this.props.matchParams;
    const { menuItems } = this.props;
    
    const whosHereId = getWhosHereId(menuItems);
    
    const attendeesListUrl = `/apps/${appId}/events/${eventId}/whos_here/${whosHereId}/${TAB_ATTENDEES}`;
    this.props.history.push(attendeesListUrl);
  };

  render() {
    const { t, theme, user, scannedAttendeesIds, canTakeNotes } = this.props;
    const { showScanner } = this.state;

    if (showScanner) {
      return (
        <QRCodeScanner
          onScan={this.handleScanResult}
          onClose={this.handleCloseScanner}
          onManualSearch={this.handleManualSearch}
        />
      );
    }

    return (
      <CardIcon
        padding={'50px 20px 20px 20px'}
        logoBorderRadius={'50%'}
        image={user.avatar_url}
        theme={theme}
      >
        <UserContainer>
          <UserName>
            {user.first_name} {user.last_name}
          </UserName>
          <UserJob>{getJobWithCompany(user.job_title, user.company)}</UserJob>

          <QrCodeHeading>{t('my_qr_code')}</QrCodeHeading>
          <QrCode src={`data:image/svg+xml;base64,${user.barcode}`} />
          <HelpText>{t('qr_code_helper')}</HelpText>

          {canTakeNotes && (
            <div style={{ marginTop: '30px' }}>
              <Button
                btntype={'primary'}
                onClick={this.onClickScanAttendee}
                width={'100%'}
                margin={'0 0 15px 0'}
              >
                {t('scan_an_attendee')}
              </Button>
              <Button
                btntype={'secondary'}
                onClick={this.onClickPeopleScanned}
                width={'100%'}
                margin={'0'}
              >
                {t('people_scanned')} ({scannedAttendeesIds ? scannedAttendeesIds.length : 0})
              </Button>
            </div>
          )}
        </UserContainer>
      </CardIcon>
    );
  }
}

export default UserQrCode;
